import React from "react";
import { Link } from "react-router-dom";

function RightNavigationArrow({
  position = "absolute",
  top,
  left,
  right,
  bottom,
  height,
  width,
  children,
  link,
  backgroundColor = "red",
}) {
  const positionStyle = {
    position,
    ...(top !== undefined && { top }),
    ...(left !== undefined && { left }),
    ...(right !== undefined && { right }),
    ...(bottom !== undefined && { bottom }),
    ...(height !== undefined && { height }),
    ...(width !== undefined && { width }),
    backgroundColor,
  };

  return (
    <Link to={link}>
      <button
        type="button"
        className="right_btn_naviagation_arrow"
        style={positionStyle}
      >
        <img
          src={children}
          alt=""
          style={{
            height: "unset",
            backgroundColor: "red",
            width: "100%",
            borderRadius: "unset",
            padding: "3px",
            objectFit: "unset",
          }}
        />
      </button>
    </Link>
  );
}

export default RightNavigationArrow;
